import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { readStoredItem, writeStoredItem } from 'src/utils/storageManager';

const LAST_GREETING_KEY = 'baobab_last_profile_picker_greeting';
const GREETINGS_COUNT = 7;

const pickGreetingIndex = () => {
  const last = Number(readStoredItem(LAST_GREETING_KEY) ?? -1);
  const index = Math.floor(Math.random() * (GREETINGS_COUNT - 1));
  return index >= last && last >= 0 ? index + 1 : index;
};

const useBaoGreeting = () => {
  const { t } = useTranslation();
  const [greetingIndex] = useState(pickGreetingIndex);

  useEffect(() => {
    writeStoredItem(LAST_GREETING_KEY, String(greetingIndex));
  }, [greetingIndex]);

  // i18next-extract-mark-keys-start
  // t('login.profilePicker.greetings.0')
  // t('login.profilePicker.greetings.1')
  // t('login.profilePicker.greetings.2')
  // t('login.profilePicker.greetings.3')
  // t('login.profilePicker.greetings.4')
  // t('login.profilePicker.greetings.5')
  // t('login.profilePicker.greetings.6')
  // i18next-extract-mark-keys-end
  const greeting = t(`login.profilePicker.greetings.${greetingIndex}`);

  return { greeting, greetingIndex };
};

export default useBaoGreeting;
